import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect } from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";

var PopoverTrigger = function PopoverTrigger(_ref) {
  var ariaLabel = _ref.ariaLabel,
      triggerNode = _ref.triggerNode,
      handleClick = _ref.handleClick,
      handleKeyEnter = _ref.handleKeyEnter,
      handleMouseEnter = _ref.handleMouseEnter,
      handleMouseLeave = _ref.handleMouseLeave,
      idForContent = _ref.idForContent,
      isActive = _ref.isActive,
      triggerRef = _ref.triggerRef,
      _ref$ariaLabelledById = _ref.ariaLabelledById,
      ariaLabelledById = _ref$ariaLabelledById === void 0 ? "" : _ref$ariaLabelledById,
      _ref$triggerClassName = _ref.triggerClassName,
      triggerClassName = _ref$triggerClassName === void 0 ? "" : _ref$triggerClassName,
      triggerId = _ref.triggerId,
      onToggle = _ref.onToggle;
  var getClassName = getClassNameFactory(PopoverTrigger.displayName);
  useEffect(function () {
    // applying escape listener to the whle page since escape should close popover even when tabbing through the items
    var handleEscapeButtonPress = function handleEscapeButtonPress(e) {
      if (e.key === "Escape" && isActive) {
        onToggle();
        var triggerElement = document.getElementById(triggerId);

        if (triggerElement) {
          return triggerElement.focus();
        }
      }
    };

    document.addEventListener("keyup", handleEscapeButtonPress);
    return function () {
      document.removeEventListener("keyup", handleEscapeButtonPress);
    };
  }, [isActive]);

  var labelProps = _objectSpread({}, ariaLabelledById ? {
    "aria-labelledby": ariaLabelledById
  } : {
    "aria-label": ariaLabel
  });

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      states: classNames({
        active: isActive
      })
    })
  }, /*#__PURE__*/React.createElement("div", _extends({
    id: triggerId,
    "aria-controls": idForContent,
    "aria-haspopup": "true"
  }, labelProps, {
    "aria-expanded": isActive,
    className: classNames(getClassName({
      descendantName: "container"
    }), triggerClassName),
    onClick: handleClick,
    onKeyDown: handleKeyEnter,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: triggerRef,
    role: "button",
    tabIndex: 0
  }), triggerNode));
};

PopoverTrigger.displayName = "PopoverTrigger";
export default PopoverTrigger;